var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper",style:({
    backgroundImage: ("url(" + _vm.backgroundImage + ")"),
    backgroundPosition: 'center',
    backgroundSize: 'cover',
  }),on:{"click":_vm.goTo}},[_c('div',{staticClass:"main"},[_c('h1',[_vm._v(_vm._s(_vm.title))]),_c('p',{staticClass:"bottom"},[_vm._v(_vm._s(_vm.coins))])])])}
var staticRenderFns = []

export { render, staticRenderFns }